
export type SupportedLocale = 'es' | 'en';

export const DEFAULT_LOCALE: SupportedLocale = 'es';

export const AVAILABLE_LOCALES: SupportedLocale[] = ['es', 'en'];

export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  es: 'Español',
  en: 'English'
};

export const getLocalePath = (locale: SupportedLocale) => {
  if (locale === DEFAULT_LOCALE) return '/';
  return `/${locale}`;
};
